export interface HmacPayload {
  payload: string;
  timestamp: string;
  signature: string;
}

export async function createHmacSignature(
  payload: string
): Promise<HmacPayload> {
  const timestamp: string = Date.now().toString();
  const message: string = `${payload}.${timestamp}`;

  const encoder = new TextEncoder();

  const key: CryptoKey = await crypto.subtle.importKey(
    "raw",
    encoder.encode("pk_secretKey_LastminuteWellness-hashedkey"),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  const signatureBuffer: ArrayBuffer = await crypto.subtle.sign(
    "HMAC",
    key,
    encoder.encode(message)
  );

  const signature: string = btoa(
    String.fromCharCode(...new Uint8Array(signatureBuffer))
  );

  return {
    payload,
    timestamp,
    signature
  };
}
